import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ num, label }) => (
  <div className="flex items-center gap-5 mb-8" data-testid={`chapter-${num}`}>
    <span className="font-display text-6xl md:text-7xl font-black leading-none text-gold/20 select-none">{num}</span>
    <div>
      <span className="block text-xs md:text-sm tracking-[0.3em] uppercase text-gold font-semibold">{label}</span>
      <span className="block mt-2 h-px w-24 bg-gradient-to-r from-gold/60 to-transparent" />
    </div>
  </div>
);
